import { LinearProgress, Paper, styled } from '@mui/material';

export const StyledGoalsCreateWrap = styled(Paper)({
	borderRadius: '20px',
	padding: '24px',
});

export const StyledGoalsCreateLiearProgress = styled(LinearProgress)({
	position: 'absolute',
	top: 0,
	left: 0,
	right: 0,
	background: '#E8F4FF',
});
